// src/components/UserContractView/components/StatsCard.jsx

import React from 'react';
import { Box, Typography, Card, CardContent, Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const StatsCard = ({ title, value, icon, color = 'primary', subtitle }) => {
  const theme = useTheme();
  
  const colorMap = {
    primary: { bg: theme.palette.primary.main, light: theme.palette.primary.light },
    warning: { bg: theme.palette.warning.main, light: theme.palette.warning.light },
    success: { bg: theme.palette.success.main, light: theme.palette.success.light },
    error: { bg: theme.palette.error.main, light: theme.palette.error.light },
  };

  const colors = colorMap[color] || colorMap.primary;

  return (
    <Card 
      sx={{ 
        height: '100%', 
        background: `linear-gradient(135deg, ${colors.bg} 0%, ${colors.light} 100%)`,
        color: 'white'
      }}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)', mb: 1, fontWeight: 500 }}>
              {title}
            </Typography>
            <Typography variant="h3" sx={{ color: 'white', fontWeight: 700 }}>
              {value}
            </Typography>
            {subtitle && (
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.85)', mt: 0.5, display: 'block' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          <Avatar sx={{ bgcolor: 'rgba(255, 255, 255, 0.25)', width: 56, height: 56 }}>
            {React.cloneElement(icon, { sx: { fontSize: 32, color: 'white' } })}
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatsCard;